<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
      <b-nav-text class="banner" v-if="showBanner">
        Please note: the transition to a new supplier for video calls has been paused, please continue using purple visits until further notice.
      </b-nav-text>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0" v-if="user">
              {{user.username}}
            </p>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/user.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item :to="{ name: 'profile' }" link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item @click="logOutUser()" link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

<!--    <nav-filters v-if="user && filters"></nav-filters>-->
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue';
  // import NavFilters from '../../components/chartFilters/NavFilters.vue';

  export default {
    components: {
      // Navbar Components
      DarkToggler,
      // NavFilters,
    },
    props: {
      toggleVerticalMenuActive: {
        type: Function,
        default: () => {},
      },
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
        filters: state => state.stats.filters,
      }),
      showBanner() {
        const {prison} = this.$store.state.prison;
        return prison && prison.group_id === '21a4a4957bfd41c1836ac1d127581975' && !prison.latest_booking_date;
      },
    },
    mounted() {
    },
    methods: {
      logOutUser() {
        this.$store.dispatch('auth/clearLocalUser');
        this.$store.commit('stats/SET_LOADED', false);
        this.$router.push('/login');
      },
    },
  }
</script>

<style>
.banner {
  color: #bc47d3 !important;
  font-weight: bold;
  width: 100%;
  text-align: center;
}
</style>
